import clsx from "clsx";
import React from "react";
import { BlockText } from "./PageContent/BlockText";
export default function FullWidth(param) {
    var markup = param.markup, _param_boxedWidth = param.boxedWidth, boxedWidth = _param_boxedWidth === void 0 ? false : _param_boxedWidth, _param_grayBackground = param.grayBackground, grayBackground = _param_grayBackground === void 0 ? false : _param_grayBackground, rawHtml = param.rawHtml;
    var cleanMarkup = function(str) {
        return str.replace(/<\/?[^>]+>|\n/g, "").trim();
    };
    var isEmpty = cleanMarkup(markup).length === 0;
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx("px-6 md:pl-14 md:pr-36 lg:px-14 pb-3 md:py-16 lg:py-24 pt-12 relative content-text-bg", {
            "bg-gray-30": grayBackground,
            "w-full": !boxedWidth,
            "max-w-3xl mx-auto": boxedWidth
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx({
            "w-full": !boxedWidth,
            "max-w-3xl mx-auto": boxedWidth // Apply max-width only when boxed
        })
    }, !isEmpty && /*#__PURE__*/ React.createElement(BlockText, {
        markup: markup
    }), /*#__PURE__*/ React.createElement("div", {
        dangerouslySetInnerHTML: {
            __html: rawHtml !== null && rawHtml !== void 0 ? rawHtml : ""
        },
        style: {
            marginTop: "0px"
        }
    })));
}
